import React from "react";
import Heading from "../../components/Heading";
import "../../css/dealers.css";
import { SpiceDetails, Misc } from "../../Constants/productListConstant";
import { Button } from "react-bootstrap";
import axios from "axios";
import swal from "sweetalert2";
import { validationForEmail } from "../../js/regex";
import qs from "qs";
import PropTypes from "prop-types";
import { ClipLoader } from "react-spinners";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import ReactPixel from "react-facebook-pixel";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/libphonenumber.js";
import "react-intl-tel-input/dist/main.css";
import { CountryDropdown } from "react-country-region-selector";
import productList from "../../Constants/projectList";

let duration = 400;
let productInfo = {};
const handler = (status, value, countryData, number, id) => {
  // // console.log(status, value, countryData, number, id)
};
const WeightView = ({ handleQuantity, id, infoId, product }) => {
  return (
    <div className="wt">
      <div className="wt-qty">{product.size}</div>
      <div className="input-qty">
        <div className="input-group-btn">
          <button
            onClick={() => handleQuantity("sub", id, infoId)}
            type="button"
            className="quantity-left-minus btn btn-default btn-number"
            data-type="minus"
            data-field=""
          >
            <span className="glyphicon glyphicon-minus" />
          </button>
        </div>
        <input type="text" id="quantity" name="quantity" className="form-control input-number" value={product.quantity || 0} min="0" max="100" />
        <div className="input-group-btn">
          <button
            onClick={() => handleQuantity("add", id, infoId)}
            type="button"
            className="quantity-right-plus btn btn-default btn-number"
            data-type="plus"
            data-field=""
          >
            <span className="glyphicon glyphicon-plus" />
          </button>
        </div>
      </div>
    </div>
  );
};

WeightView.propTypes = {
  handleQuantity: PropTypes.func,
  id: PropTypes.string,
  infoId: PropTypes.string,
  product: PropTypes.object,
};

export class DealerView extends React.Component {
  constructor(args) {
    super(args);
    this.inputs = ["Name", "Email", "Reference", "Phn", "Address", "City", "Country"];
    this.state = {
      Error: {},
      values: {},
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
        padding: "30px 0 0",
      },
      change: false,
      loader: false,
    };
    this.quantityBucketById = {};
    this.SpiceDetailsByIds = {};
    this.totalProduct = [...SpiceDetails, ...Misc];
    this.productList = {};
    this.totalProduct.map((item) => {
      this.SpiceDetailsByIds[item.id] = item;
      return item;
    });
  }
  componentDidMount() {
    ReactPixel.init("145006083100066");
    ReactPixel.track("ViewContent", location);

    productList.map((item) => {
      if (!this.productList[item.id]) {
        this.productList[item.id] = {
          productName: item.product_name,
          info: {},
        };
      }
      this.productList[item.id].info = {
        ...this.productList[item.id].info,
        [item.info_id]: {
          size: item.size,
          MRP: item.MRP,
          packType: item.pack_type,
          type: item.type_id,
          quantity: 0,
        },
      };
    });
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
          padding: "30px 0 0",
        },
      });
    }, 500);
  }
  selectCountry(val) {
    this.setState({
      values: {
        ...this.state.values,
        Country: val,
      },
      isChange: false,
    });
    setTimeout(() => {
      this.setState({
        isChange: true,
      });
    }, 1000);
  }
  handleQuantity = (fn, id, infoId) => {
    if (fn === "add") {
      this.productList[id].info[infoId].quantity = this.productList[id].info[infoId].quantity + 1;
    } else if (fn === "sub" && this.productList[id].info[infoId].quantity > 0) {
      this.productList[id].info[infoId].quantity = this.productList[id].info[infoId].quantity - 1;
    }
    this.setState({
      change: !this.state.change,
    });
  };
  handleChangeAndValidation = (key, e) => {
    let { Error } = this.state;
    this.setState({
      values: {
        ...this.state.values,
        [key]: e.target.value,
      },
    });
    delete Error[key];
  };
  handleSubmit = () => {
    const { values } = this.state;
    let isFlag = false;
    let error = {};
    // eslint-disable-next-line
    this.inputs.map((item) => {
      if (!values[item] && item !== "Reference") {
        isFlag = true;
        error[item] = true;
      } else if (item === "Email") {
        error[item] = !validationForEmail(values[item]);
        isFlag = error[item];
      }
    });
    if (isFlag) {
      this.setState({
        Error: error,
      });
    } else {
      let pr = [];

      // Object.keys(productInfo).map((item, i) => pr.push(productInfo[item]));
      Object.keys(this.productList).map((item, i) => pr.push(this.productList[item]));
      // console.log(pr);

      let proQTYArray = qs.stringify({ product_details: pr });
      let params = `username=${values.Name}&
					email=${values.Email}&
					phone=${values.Phn}&
					refrences=${values.Reference || ""}&
					city=${values.City}&
					country=${values.Country}&
					address=${values.Address}&
					${proQTYArray}`;
      //   console.log(JSON.parse(proQTYArray));

      const data = {
        name: values.Name,
        email: values.Email,
        phone: values.Phn,
        reference: values.Reference || "",
        city: values.City,
        country: values.Country,
        address: values.Address,
      };

      let productQuantities = pr.map((product) => {
        let quan = [];
        Object.keys(product.info).map((item) => quan.push(product.info[item]));
        // console.log(quan);

        let nonZeroEntries = quan.filter((item) => item.quantity > 0);

        let string = `${product.productName}: `;

        // nonZeroEntries.forEach(string);
        for (let i = 0; i < nonZeroEntries.length; i++) {
          const variant = nonZeroEntries[i];

          let pack = "";
          if (variant.packType === 2) {
            pack = "Boxes";
          } else if (variant.packType === 1) {
            pack = "Pouches";
          }

          string += `${variant.size} (${pack}) x ${variant.quantity}, `;
        }

        if (nonZeroEntries.length > 0) {
          return string;
        } else {
          return null;
        }
      });

      let nonZeroEntries = productQuantities.filter((item) => item !== null);

      if (!nonZeroEntries || nonZeroEntries.length === 0) {
        data.quantities = "No products selected";
      } else {
        data.quantities = nonZeroEntries.join(", ");
      }

      console.log(data.quantities, "quantities");
      // console.log(params);
      // return;

      // https://blackelephantdigital.in/blackele/sunny/api/bmc-api/public/dealerConnect?${params}
      swal({
        title: "Submitting Request...",
        onOpen: () => {
          swal.showLoading();
        },
      });
      ReactPixel.track("Contact", { dealer: true, values });

      axios
        .post(`https://bawamasalacompany.com/api/public/index.php/dealerenquiry`, data)
        .then((response) => {
          swal.close();
          swal({
            title: "Successfully Submitted",
            html: `<div style='text-align: center'>Thank you for getting in touch!</div>`,
            type: "success",
          });
          return response;
        })
        .catch((e) => {
          swal({
            title: "Warning",
            html: `<div style='text-align: center'>Internal Server error</div>`,
            type: "error",
          });
        });
    }
  };
  render() {
    const { defaultStyle, Error, loader, values } = this.state;
    const { location } = this.props;
    // let counter = 0
    let item = {};
    let total;
    return (
      <ContentPage>
        <Meta
          title="BMC Dealerships | Enquiry Form & Product List"
          description="BMC Dealers are proud associations in the legacy of excellence of over 7 decades. Fill in the enquiry form today and view the full Bawa Masala Company Product List."
          location={location}
        />
        <div className="global__wrapper">
          <div className="dealers__wrapper" style={defaultStyle}>
            <Heading title="BMC dealers and stockists" size="large" />
            <div className="dealers__sub__heading">
              Dealer enquiries solicited For regional dealerships PAN India (Except For Delhi, U.P., Punjab, Uttarakhand, Haryana & U.T. of Chandigarh, for
              which{" "}
              <a style={{ textDecoration: "underline" }} href="https://bawaindustries.com/" target="__blank">
                Bawa Industries
              </a>{" "}
              is available) and abroad.
            </div>
            <div className="dealers__steps">
              <h2 className="dealers__steps__title">Become a BMC Dealer</h2>
              <div className="dealers__steps__grid">
                <div className="dealers__steps__item">
                  <span className="dealers__steps__number">1</span>
                  <h3 className="dealers__steps__heading">Enquire</h3>
                  <p className="dealers__steps__text">Submit the form below with your details and product interests. We'll get back to you within 48 hours.</p>
                </div>
                <div className="dealers__steps__item">
                  <span className="dealers__steps__number">2</span>
                  <h3 className="dealers__steps__heading">Discuss Territory & Terms</h3>
                  <p className="dealers__steps__text">Our team will reach out to understand your market, discuss territorial coverage, and finalize commercial terms.</p>
                </div>
                <div className="dealers__steps__item">
                  <span className="dealers__steps__number">3</span>
                  <h3 className="dealers__steps__heading">Onboarding</h3>
                  <p className="dealers__steps__text">Once terms are agreed, we'll share product catalogs, pricing, and marketing support to help you get started.</p>
                </div>
                <div className="dealers__steps__item">
                  <span className="dealers__steps__number">4</span>
                  <h3 className="dealers__steps__heading">Start Ordering</h3>
                  <p className="dealers__steps__text">Place your first order and begin stocking BMC's premium Indian spices — trusted since 1952.</p>
                </div>
              </div>
            </div>
            <div className="dealers__form">
              <form>
                <div className="row">
                  <div className="col-md-4">
                    <div className="title">
                      Name <span className="amp">*</span>
                    </div>
                    <input type="text" onChange={(e) => this.handleChangeAndValidation("Name", e)} className="form-control" name="name" />
                    {Error.Name ? <div className="error-msg">Name is mandatory</div> : null}
                  </div>
                  <div className="col-md-4">
                    <div className="title">
                      Phone <span className="amp">*</span>
                    </div>
                    <IntlTelInput
                      onPhoneNumberChange={(status, value, countryData, Phn, id) => this.setState({ values: { ...values, Phn: Phn } })}
                      onPhoneNumberBlur={handler}
                      onChange={(e) =>
                        this.setState({
                          values: { ...values, Phn: e.target.value },
                        })
                      }
                      defaultCountry="in"
                      Default={["in"]}
                      css={["intl-tel-input", "form-control"]}
                      utilsScript={"libphonenumber.js"}
                      name="Phn"
                    />
                    {Error.Phn ? <div className="error-msg">Contact Number is mandatory</div> : null}
                  </div>
                  <div className="col-md-4">
                    <div className="title">
                      Email <span className="amp">*</span>
                    </div>
                    <input type="text" onChange={(e) => this.handleChangeAndValidation("Email", e)} className="form-control" name="Contact" />
                    {Error.Email ? <div className="error-msg">Email is mandatory and should be validated</div> : null}
                  </div>
                </div>
                <div className="row" />
                <div className="row">
                  <div className="col-md-4">
                    <div className="title">
                      City <span className="amp">*</span>
                    </div>
                    <input type="text" onChange={(e) => this.handleChangeAndValidation("City", e)} className="form-control" name="City" />
                    {Error.City ? <div className="error-msg">City is mandatory</div> : null}
                  </div>
                  <div className="col-md-4">
                    <div className="title">
                      Country <span className="amp">*</span>
                    </div>
                    <CountryDropdown className="form-control" value={this.state.values.Country} onChange={(val) => this.selectCountry(val)} name="Country" />
                    {Error.Country ? <div className="error-msg">Country is mandatory</div> : null}
                  </div>
                  <div className="col-md-4">
                    <span className="title">Reference</span>
                    <input type="text" onChange={(e) => this.handleChangeAndValidation("Reference", e)} className="form-control" name="Email" />
                  </div>
                  <div className="col-md-12">
                    <span className="title">
                      Address <span className="amp">*</span>
                    </span>
                    <textarea
                      style={{ width: "97%", margin: "0 auto" }}
                      onChange={(e) => this.handleChangeAndValidation("Address", e)}
                      className="form-control"
                      rows="2"
                    />
                    {Error.Address ? <div className="error-msg">Address is mandatory</div> : null}
                  </div>
                </div>
              </form>
            </div>
            <div className="mobile-text">For a full product list for Dealer orders, kindly view this page on a desktop or laptop.</div>
            <div className="dealers__table">
              <div className="sub__heading">product list</div>
              <div className="title">BMC Masale</div>
              <div className="product__table">
                {loader ? (
                  <div style={{ margin: "10% 50% 10%" }}>
                    <ClipLoader color={"#19217a"} loading={loader} />
                  </div>
                ) : (
                  <table>
                    <tbody>
                      <tr>
                        <th colSpan="2" scope="colgroup">
                          S.no
                        </th>
                        <th colSpan="2" scope="colgroup">
                          Product
                        </th>
                        <th colSpan="4" scope="colgroup">
                          Weight
                        </th>
                        <th colSpan="2" scope="colgroup">
                          Total Quantity
                        </th>
                      </tr>
                      <tr>
                        <th colSpan="2" scope="colgroup" />
                        <th colSpan="2" scope="colgroup" />
                        <th colSpan="2" scope="colgroup">
                          Boxes
                        </th>
                        <th colSpan="2" scope="colgroup">
                          Pouches
                        </th>
                        <th colSpan="2" scope="colgroup" />
                      </tr>
                    </tbody>
                    <tbody>
                      {!loader &&
                        Object.keys(this.productList).map((key, i) => {
                          item = this.productList[key];
                          total = ``;
                          // if (item.packType === 1 && (item.type === "Spices" || item.type === "Misc")) {
                          // 	let total = ""
                          // 	if (this.quantityBucketById[item.id] > 0 && this.quantityBucketById[item.miniPackWeight] > 0) {
                          // 		total = `${item.netWeight} x ${this.quantityBucketById[item.id] * 150}pkts, ${this.SpiceDetailsByIds[item.miniPackWeight].netWeight} x ${this.quantityBucketById[item.miniPackWeight] * 100}pkts`
                          // 	} else if (this.quantityBucketById[item.id] > 0) {
                          // 		total = `${item.netWeight} x ${this.quantityBucketById[item.id] * 150}pkts`
                          // 	} else if (this.quantityBucketById[item.miniPackWeight] > 0) {
                          // 		total = `${this.SpiceDetailsByIds[item.miniPackWeight].netWeight} x ${this.quantityBucketById[item.miniPackWeight] * 100}pkts`
                          // 	} else {
                          // 		total = "-"
                          // 	}
                          // 	counter++
                          return (
                            <tr key={i}>
                              <td colSpan="2">{i + 1}</td>
                              <td colSpan="2" className="product_name">
                                {item.productName}
                              </td>
                              <td colSpan="2" className="wt">
                                {Object.keys(item.info).map((infoId, i) => {
                                  let product = item.info[infoId];
                                  if (product.packType === 2) {
                                    total =
                                      product.quantity > 0
                                        ? `${total}<li>${product.size} ${product.type === "Dhoop" ? "(Packets)" : "(Box)"} x ${product.quantity * 150}</li>`
                                        : total;
                                    return <WeightView key={infoId} handleQuantity={this.handleQuantity} id={key} infoId={infoId} product={product} />;
                                  } else {
                                    return "";
                                  }
                                })}
                              </td>
                              <td colSpan="2" className="wt">
                                {Object.keys(item.info).map((infoId) => {
                                  let product = item.info[infoId];
                                  if (product.packType === 1) {
                                    total =
                                      product.quantity > 0
                                        ? `${total}<li>${product.size} ${product.type === "Dhoop" ? "(Packets)" : "(Pouch)"} x ${product.quantity * 150}</li>`
                                        : total;
                                    return <WeightView key={infoId} handleQuantity={this.handleQuantity} id={key} infoId={infoId} product={product} />;
                                  } else {
                                    return "";
                                  }
                                })}
                              </td>
                              <td colSpan="2">
                                <span className="total-qty">
                                  <ul dangerouslySetInnerHTML={{ __html: total }} />
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
              </div>
              {/*
								<div className="title">
									BMC Industries
								</div>
								<div className="product__table">
									<table>
										<tr>
											<th colSpan="2" scope="colgroup">S.no</th>
											<th colSpan="2" scope="colgroup">Product</th>
											<th colSpan="2" scope="colgroup">Quantity</th>
											<th colSpan="2" scope="colgroup">Total Quanitity</th>
										</tr>
										<tbody>
											{this.totalProduct.map((item, i) => {
												console.log("BEDSDSd", item)
												if (item.type === "Dhoop") {
													let total = ""
													if (this.quantityBucketById[item.id] > 0) {
														total = `${item.netWeight} x ${this.quantityBucketById[item.id] * 150}pkts`
													} else {
														total = "-"
													}
													counterBi++
													return (
														<tr key={i}>
															<td colSpan="2">{counterBi}</td>
															<td colSpan="2">{item.productName}</td>
															<td colSpan="2" className="wt">
																<div className="wt-qty">{item.netWeight} x 150pkts</div>
																<div className="input-qty">
																	<div className="input-group-btn">
																		<button onClick={() => this.handleQuantity("sub", item.id)} type="button" className="quantity-left-minus btn btn-default btn-number" data-type="minus" data-field="">
																			<span className="glyphicon glyphicon-minus" />
																		</button>
																	</div>
																	<input type="text" id="quantity" name="quantity" className="form-control input-number" value={this.quantityBucketById[item.id] || 0} min="0" max="100" />
																	<div className="input-group-btn">
																		<button onClick={() => this.handleQuantity("add", item.id)} type="button" className="quantity-right-plus btn btn-default btn-number" data-type="plus" data-field="">
																			<span className="glyphicon glyphicon-plus" />
																		</button>
																	</div>
																</div>
															</td>
															<td colSpan="2">
																<span>{total}</span>
															</td>
														</tr>
													)
												}
											})}
										</tbody>
									</table>
								</div>
						*/}
            </div>
            <div className="submit-btn">
              <Button onClick={this.handleSubmit}>Submit</Button>
            </div>
          </div>
        </div>
      </ContentPage>
    );
  }
}

export default DealerView;



// WEBPACK FOOTER //
// ./src/pages/dealers/index.js